import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 18,
	viewBox: "0 0 24 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M22.5 10.0635L19.218 15.2525L15.8125 11.009L7.7825 15.2525L1.5 4.875",
				stroke: "#EA580C",
				strokeWidth: 1.2,
				strokeLinecap: "square"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M1.5 14.55L4.5535 14.1275L8.003 9.884L11.2845 11.8755L15.1195 6.7235L18.512 9.8835L22.5 3.75",
				stroke: "#5946E5",
				strokeWidth: 1.2,
				strokeLinecap: "square"
			})]
		})
	})
});
export default SvgLine;
